import { render, staticRenderFns } from "./SupportingDocuments.view.vue?vue&type=template&id=56031874&"
import script from "./SupportingDocuments.view.vue?vue&type=script&lang=js&"
export * from "./SupportingDocuments.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56031874')) {
      api.createRecord('56031874', component.options)
    } else {
      api.reload('56031874', component.options)
    }
    module.hot.accept("./SupportingDocuments.view.vue?vue&type=template&id=56031874&", function () {
      api.rerender('56031874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/supplier-requirements/SupportingDocuments.view.vue"
export default component.exports